export const BLOGS_ON_GET_ALL_REQUESTED = 'BLOGS_ON_GET_ALL_REQUESTED';
export const BLOGS_ON_GET_ALL_SUCCEEDED = 'BLOGS_ON_GET_ALL_SUCCEEDED';
export const BLOGS_ON_GET_ALL_FAILED = 'BLOGS_ON_GET_ALL_FAILED';

export const BLOGS_ON_GET_ONE_REQUESTED = 'BLOGS_ON_GET_ONE_REQUESTED';
export const BLOGS_ON_GET_ONE_SUCCEEDED = 'BLOGS_ON_GET_ONE_SUCCEEDED';
export const BLOGS_ON_GET_ONE_FAILED = 'BLOGS_ON_GET_ONE_FAILED';
